// extracted by mini-css-extract-plugin
export default {"form":"search_form__AV+EA","content__wrapper":"search_content__wrapper__eDJ84","todoText":"search_todoText__mDJCk","todoInput":"search_todoInput__8MUvj"};